export default __webpack_public_path__ + "static/media/signup.5279a33b.jpg";